import { assert_false, assert_not_null } from '@shared/asserts/utils_asserts';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../../_fields/_base/FIELD__base';
import { ENUM__invocation_role as ENUM } from '../../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_SD__denoise_latents_pipeline } from '../../../_invocations/sd/denoise/INVOCATION_SD__denoise_latents_pipeline';
import { INVOCATION_SD__lora_select } from '../../../_invocations/sd/guidance/INVOCATION_SD__lora_select';
import { INVOCATION_SD__text_encoder } from '../../../_invocations/sd/guidance/INVOCATION_SD__text_encoder';
import { ENUM__graph_template_name } from '../ENUM__graph_template_name';

export function GENERATION_TOOL__sd1__select_loras(tool: DTO__generation_tool) {
  let { graph } = tool;

  assert_not_null(graph);
  assert_false(graph.is_stub());

  /*
   *
   */

  const node__loras_select = INVOCATION_SD__lora_select.create_node_for(graph, ENUM.CORE__LORAS_SELECT);

  const node__text_encoder_global = INVOCATION_SD__text_encoder.create_node_for(graph, ENUM.CORE__TEXT_ENCODER);

  const node__denoise = INVOCATION_SD__denoise_latents_pipeline.create_node_for(graph, ENUM.CORE__DENOISE);

  /*
   * LORA LOADER
   */

  const node__lora_selector = INVOCATION_SD__lora_select.create_node_for(graph, ENUM.CORE__LORAS_SELECT);

  graph.edge__try_add_for_fields(node__lora_selector.loras, node__text_encoder_global.clip.loras);
  graph.edge__try_add_for_fields(node__lora_selector.loras, node__denoise.unet.loras);

  /*
   * UI
   */

  let fields__visible: FIELD__base[] = [
    node__loras_select.loras,
    node__loras_select.grid2d_mode__lora_after_lora,
    node__loras_select.grid2d_mode__lora_vs_lora,
    node__loras_select.grid2d_mode__single_lora_generation,
    node__loras_select.grid2d_mode__all_loras_except_one,
  ];

  tool.view__add({
    name: ENUM__graph_template_name.SELECT_LORAS,
    group: '3. Models',
    //
    fields__visible,
    fields__stored: fields__visible,
    //
    field_ids_info__items_amount: [node__loras_select.loras.meta.field_id],
  });
}
